// pages that have tour in mobile
export const mobileTours = ["/nr/login/public", "/nr/login/checklist"];
